import React from 'react';

export interface RadioOption {
  label: string;
  value: string;
}

interface Props {
  label?: string;
  options: RadioOption[];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  filterState: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onChange: (value: any) => void;
  onClear?: () => void;
  className?: string;
}

export const RadioGroup: React.FC<Props> = (props) => {
  const { label, options, filterState, onChange, onClear, className } = props;

  return (
    <fieldset>
      {label && <legend className="text-xs font-medium text-gray-900">{label}</legend>}
      <div className={`flex items-center my-3 ${className}`}>
        {options.map((option) => (
          <div className="mr-6" key={option.value}>
            <input
              id={option.value}
              name={label}
              type="radio"
              className="h-4 w-4 mr-2 border-gray-300 text-blue-600 cursor-pointer focus:ring-blue-600"
              value={option.value}
              checked={filterState === option.value}
              onChange={() => onChange(option.value)}
            />
            <label
              className="text-md font-medium leading-6 text-gray-600 cursor-pointer"
              htmlFor={option.value}
            >
              {option.label}
            </label>
          </div>
        ))}
        {onClear && (
          <div>
            {filterState !== null ? (
              <button
                type="button"
                className="rounded bg-blue-100 py-1 px-2 text-sm font-semibold text-blue-600 hover:bg-blue-200"
                onClick={onClear}
              >
                Clear
              </button>
            ) : null}
          </div>
        )}
      </div>
    </fieldset>
  );
};
